import Table from 'components/Table';
import { ITableProps, MobileTableType } from 'components/Table/types';
import React from 'react';

import { ITransactionActivityTableProps } from '../types';

const TransactionLogTable: React.FC<ITableProps<ITransactionActivityTableProps>> = (tableProps) => (
  <Table
    className='base-structure-wrapper'
    {...tableProps}
    mobileDesignType={MobileTableType.RESPONSIVE_TABLE}
    widthThreshold={575}
  />
);

export default React.memo(TransactionLogTable);
